export default "__VITE_ASSET__5d7019b4__"